const { throttle } = require("throttle-debounce");

const lazyblocks = new Set();
let isLoaded = false;

const findLazyOnce = (function () {
    let executed = false;
    return function () {
        if (!executed) {
            executed = true;

            $(".lazyblock").each(function () {
                lazyblocks.add(this);
            });
        }
    };
})();

function animateLazy() {
    findLazyOnce();

    if (lazyblocks.size === 0) return;

    const scrollTop = $(window).scrollTop();
    const scrollBottom = scrollTop + $(window).height();

    lazyblocks.forEach(function (item) {
        const offsetTop = $(item).offset().top;
        const offsetTranslate = 100;
        const isInViewport = scrollBottom > offsetTop - offsetTranslate;
        const delay =
            $(item).hasClass("materials") && scrollTop === 0 ? 800 : 0;

        if (isInViewport) {
            setTimeout(function () {
                $(item).addClass("animated");
            }, delay);
            lazyblocks.delete(item);
        }
    });
}

$(window).on("load", function () {
    $("#intro, #header, #footer").addClass("animated");
    $("#page__loader").hide();
    animateLazy();
    isLoaded = true;
});

$(window).on(
    "scroll",
    throttle(100, function () {
        if (!isLoaded) return;
        animateLazy();
    })
);
